import React, { useState } from "react";

import IntegrationMenu from "../Deploy/IntegrationMenu";
import Embed from "../Deploy/Embed";
import ShareComponent from "../Deploy/ShareComponent";
import Integrate from "../Deploy/Integrate";
import { useSelector } from "react-redux";
import WhatsAppIntegration from "../Deploy/WhatsAppIntegration";
import FacebookIntegration from "../Deploy/FacebookIntegration";

function Deploy({ selectedBot }) {
  const [Integratemenu, setIntegratemenu] = useState("embed");
  const [activeIntegration, setActiveIntegration] = useState({
    status: false,
    event: null,
  });

  const user = useSelector((s) => s.user?.user);
  const userId = user?.userId;
  const botId = selectedBot?.botId;

  return (
    <div className="flex flex-1 w-full  gap-4 relative p-3 sm:p-6 py-4 ">
      <div className="w-full flex-col flex ">
        <h1 className="text-2xl font-semibold text-gray-600 my-3 sm:mt-6">
          Deploy
        </h1>
        <div className="flex flex-col md:flex-row w-full gap-5 relative">
          {/* Sidebar Menu */}
          <div
            onClick={() => setActiveIntegration({ status: false, event: null })}
            className="w-full md:w-[200px]">
            <IntegrationMenu
              setIntegratemenu={setIntegratemenu}
              Integratemenu={Integratemenu}
            />
          </div>

          {/* Main Content */}
          {!activeIntegration.status && (
            <div className="flex-1 w-full">
              {Integratemenu === "embed" && (
                <Embed userId={userId} botId={botId} />
              )}
              {Integratemenu === "share" && (
                <ShareComponent userId={userId} botId={botId} />
              )}
              {Integratemenu === "integration" && (
                <Integrate
                  setActiveIntegration={setActiveIntegration}
                  userId={userId}
                  botId={botId}
                />
              )}
            </div>
          )}
          {activeIntegration.status && (
            <div className="flex flex-1">
              {activeIntegration.event === "whatsapp" && (
                <WhatsAppIntegration botId={selectedBot?.botId} />
              )}
              {activeIntegration.event === "fbmessenger" && (
                <FacebookIntegration botId={selectedBot?.botId} />
              )}
              {/* {activeIntegration.event === "instagram" && (
              <InstagramIntegration />
            )} */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Deploy;
